export default __webpack_public_path__ + "static/media/linkedin.38a90c5f.svg";